import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { CustomSelect, withTooltip } from 'components';
import { OptionType } from 'components/CustomSelect/types';
import { CaptableListProps } from './CaptableList.props';

const CaptableList = ({ cell, ...restProps }: CaptableListProps) => {
  const { onCommit, onRevert, childrenCapTables } = restProps;
  const [{ capTableList }] = useStore() as unknown as UseStoreValues;
  const getOptions = useMemo(() => {
    const tmpOptions: OptionType[] = [];

    if (capTableList && !isEmpty(capTableList)) {
      capTableList.forEach(capTable => {
        tmpOptions.push({
          label: capTable.name ?? '',
          value: capTable.id?.toString() ?? '',
        });
      });
      childrenCapTables.forEach(childCapTable => {
        tmpOptions.push({
          label: childCapTable.name ?? '',
          value: childCapTable.id?.toString() ?? '',
        });
      });
    }

    return tmpOptions;
  }, [capTableList, childrenCapTables]);

  return (
    <CustomSelect
      autoFocus
      id="captable-list"
      menuPlacement="bottom"
      onCommit={onCommit}
      onEmptyValue=""
      onRevert={onRevert}
      openMenuOnFocus
      options={getOptions}
      value={cell.value as string}
    />
  );
};

export default withTooltip(CaptableList);
